import { Injectable, inject } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ModalInfoComponent} from '../../shared/components/modal-info/modal-info.component';
import {HydraService} from './hydra.service';
import {HydraCollection} from '../../class/generic/hydra-collection';
import {MaintenanceTaskInterface} from '../../class/api/MaintenanceTask';
import {DatePipe} from '@angular/common';
import {LocalStorage} from 'ngx-webstorage';

@Injectable()
export class MaintenanceCheckService {
    private hydraService = inject(HydraService);
    private matDialog = inject(MatDialog);
    private datePipe = inject(DatePipe);


    @LocalStorage()
    private maintenanceTaskHash?: string;

    public pinnedMaintenanceTask?: MaintenanceTaskInterface | null;

    /**
     * Checks in every set frequency the version of frontend application
     *
     * @param frequency - in milliseconds, defaults to 30 minutes  1000 * 60 * 30
     */
    public initCheck(frequency = 1000 * 60) {
        // Check au démarrage
        this.checkMaintenance();

        // Vérification toutes les minutes
        setInterval(() => {
            this.checkMaintenance();
        }, frequency);
    }

    openInfos(task: MaintenanceTaskInterface): void {
        const dialog = this.matDialog.open(ModalInfoComponent, {
            width: '600px',
            data: {
                title: 'Maintenance : ' + this.datePipe.transform(task.estimatedStartDatetime, 'dd/MM/yyyy HH:mm')
                    + ' ➔ ' + this.datePipe.transform(task.estimatedEndDatetime, 'dd/MM/yyyy HH:mm'),
                content: task.message
            }
        });

        const sub = dialog.afterClosed().subscribe(
            () => sub.unsubscribe(),
            () => sub.unsubscribe()
        );
    }

    private checkMaintenance() {
        // timestamp these requests to invalidate caches
        this.hydraService.getList('/api/maintenance_tasks?alertDatetime[before]=now&estimatedEndDatetime[after]=now&itemsPerPage=1')
            .subscribe(
                (response: HydraCollection) => {
                    const tasks: MaintenanceTaskInterface[] = response.getMember();
                    if (tasks.length === 0) {
                        this.pinnedMaintenanceTask = null;
                        return;
                    }

                    const task = tasks[0];
                    const hash: string = this.buildHash(task);

                    if (!this.maintenanceTaskHash || this.maintenanceTaskHash !== hash) {
                        this.openInfos(task);
                        this.maintenanceTaskHash = hash;
                    }

                    this.pinnedMaintenanceTask = this.taskMustBePinned(task) ? task : null;

                },
                (err) => {
                    console.error(err, 'Could not get maintenance tasks');
                }
            );
    }

    private buildHash(task: MaintenanceTaskInterface): string {
        return JSON.stringify(task);
    }

    private taskMustBePinned(task: MaintenanceTaskInterface): boolean {
        return new Date(task.estimatedStartDatetime) <= new Date();
    }
}
